/*
document.addEventListener("DOMContentLoaded", function () {

    gsap.registerPlugin(ScrollTrigger);

    // Heading, Subtitle & Button
    gsap.utils.toArray("[data-heading], [data-subheading], [data-button]").forEach((el) => {

        gsap.set(el, {
            opacity: 0,
            y: 60
        });

        ScrollTrigger.create({
            trigger: el,
            start: "top 85%",

            onEnter() {
                gsap.to(el, {
                    opacity: 1,
                    y: 0,
                    duration: 0.8,
                    ease: "power3.out"
                });
            },

            onLeaveBack() {
                gsap.set(el, {
                    opacity: 0,
                    y: 60
                });
            }
        });

    });

    // Cards (One by One - Bottom → Top)
    gsap.utils.toArray("[data-card-group]").forEach((group) => {

        const cards = group.querySelectorAll("[data-card]");

        gsap.set(cards, {
            opacity: 0,
            y: 80
        });

        ScrollTrigger.create({
            trigger: group,
            start: "top 80%",

            onEnter() {
                gsap.to(cards, {
                    opacity: 1,
                    y: 0,
                    duration: 0.8,
                    stagger: 0.2,
                    ease: "power3.out"
                });
            },

            onLeaveBack() {
                gsap.set(cards, {
                    opacity: 0,
                    y: 80
                });
            }
        });

    });

});
*/

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.common-button-click');
    if (!trigger) return;

    const target = document.querySelector('campaign-widget');
    if (!target) return;

    e.preventDefault();

    const headerOffset = 100; // adjust to your sticky header height, or 0 if none
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  });


 document.addEventListener("DOMContentLoaded", function () {

  /* =========================================================
     GIFT CARD HTML
  ========================================================= */

  const giftHtml = `
    <div class="custom-gift-card">
      <div class="card-body">

        <div class="gift-title">
          <span>Free Welcome Gifts (worth 40$)</span>
        </div>

        <div class="gift-row">

          <div class="logo-box">
            <img
              src="https://cdn.shopify.com/s/files/1/0957/8024/1674/files/purple_ocean_gift_thumbnail_160.webp?v=1787326125"
              alt=""
            >
          </div>

          <div class="gift-text">

            <strong>FREE & FAST USA Shipping (15$)</strong>

          </div>

        </div>

        <div class="gift-row">

            <div class="logo-box">
              <img
                src="https://cdn.shopify.com/s/files/1/0957/8024/1674/files/purple_ocean_guide_thumbnail_160.webp?v=1787326126"
                alt=""
              >
            </div>

            <div class="gift-text">

              <strong>FREE The 90-Night Wind-Down Guide (25$)</strong>

            </div>

        </div>


      </div>
    </div>
  `;


  /* =========================================================
     MOST POPULAR
  ========================================================= */

  const mostPopularHtml = `
    <div class="gift-text-most-popular">
      <span>MOST POPULAR</span>
    </div>
  `;


  /* =========================================================
     SHIP BY DATE
     
     Today + 2 days
     
     Example:
     August 16
  ========================================================= */

  function getShipByDateText() {

    const shipDate = new Date();

    shipDate.setDate(
      shipDate.getDate() + 2
    );


    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ];


    const day =
      shipDate.getDate();

    const month =
      months[
        shipDate.getMonth()
      ];


    return `${month} ${day}`;
  }


  /* =========================================================
     GET ACTIVE PRICE
     
     Only sale price.
     Compare price is NOT used.
  ========================================================= */

  function getActivePriceText() {

    const checkedRadio =
      document.querySelector(
        ".essub-radio:checked"
      );


    let optionEl =
      checkedRadio
        ? checkedRadio.closest(
            ".essub-option--expanded, .essub-option--compact"
          )
        : null;


    /*
      Default to One-Time Purchase
      if nothing is selected yet.
    */

    if (!optionEl) {

      optionEl =
        document.querySelector(
          '.essub-options--detailed [data-option-index="2"]'
        );

    }


    if (!optionEl) {
      return null;
    }


    const priceEl =
      optionEl.querySelector(
        ".essub-pricing__sale"
      );


    if (!priceEl) {
      return null;
    }


    /*
      Get only the text node.
      Ignore /bag span.
    */

    const textNode =
      Array.from(
        priceEl.childNodes
      ).find(
        node =>
          node.nodeType === Node.TEXT_NODE &&
          node.textContent.trim()
      );


    return textNode
      ? textNode.textContent.trim()
      : priceEl.textContent
          .replace(
            "/bag",
            ""
          )
          .trim();

  }


  /* =========================================================
     COMPARE PRICE
     
     Kept here only for compatibility.
     NOT displayed anywhere.
  ========================================================= */

  function getActiveComparePriceText() {

    const checkedRadio =
      document.querySelector(
        ".essub-radio:checked"
      );


    let optionEl =
      checkedRadio
        ? checkedRadio.closest(
            ".essub-option--expanded, .essub-option--compact"
          )
        : null;


    if (!optionEl) {

      optionEl =
        document.querySelector(
          '.essub-options--detailed [data-option-index="2"]'
        );

    }


    if (!optionEl) {
      return null;
    }


    const compareEl =
      optionEl.querySelector(
        ".essub-pricing__compare"
      );


    if (!compareEl) {
      return null;
    }


    const textNode =
      Array.from(
        compareEl.childNodes
      ).find(
        node =>
          node.nodeType === Node.TEXT_NODE &&
          node.textContent.trim()
      );


    return textNode
      ? textNode.textContent.trim()
      : compareEl.textContent.trim() || null;

  }


  /* =========================================================
     UPDATE LOCK
  ========================================================= */

  let isUpdating = false;


  /* =========================================================
     UPDATE WIDGET
  ========================================================= */

  function updateWidget() {

    if (isUpdating) {
      return;
    }


    isUpdating = true;


    /* =======================================================
       TITLE + SHIP BY DATE
       
       IMPORTANT:
       Ship by is now INSIDE .essub-title.
       No separate .timetext wrapper.
    ======================================================= */

    const titleEl =
      document.querySelector(
        ".essub-title"
      );


    if (titleEl) {

      let shipByEl =
        titleEl.querySelector(
          ".title-ship-by"
        );


      /*
        Create only once.
      */

      if (!shipByEl) {

        shipByEl =
          document.createElement(
            "span"
          );


        shipByEl.className =
          "title-ship-by";


        shipByEl.innerHTML = `
          <img
            src="https://cdn.shopify.com/s/files/1/0957/8024/1674/files/Vector_19.png?v=1786013650"
            alt=""
          >
          <span>
            Ship by :
            <strong>
              ${getShipByDateText()}
            </strong>
          </span>
        `;


        titleEl.appendChild(
          shipByEl
        );

      } else {

        /*
          Update date without recreating
          the complete element.
        */

        const dateEl =
          shipByEl.querySelector(
            "strong"
          );


        if (dateEl) {

          const newDate =
            getShipByDateText();


          if (
            dateEl.textContent !==
            newDate
          ) {

            dateEl.textContent =
              newDate;

          }

        }

      }

    }


    /* =======================================================
       OPTION LAYOUT

       Row 1: option name (left) + price (right).
       Row 2: description, full width.
    ======================================================= */

    document
      .querySelectorAll(
        ".essub-option--expanded, .essub-option--compact"
      )
      .forEach(
        option => {

          const content =
            option.querySelector(
              ".essub-option__content"
            ) ||
            option.querySelector(
              ".essub-option__left-col"
            );


          if (!content) {
            return;
          }


          /*
            Create row only once.
          */

          let row =
            content.querySelector(
              ".custom-option-row"
            );


          if (!row) {

            row =
              document.createElement(
                "div"
              );


            row.className =
              "custom-option-row";


            content.insertAdjacentElement(
              "afterbegin",
              row
            );

          }


          const radioWrapper =
            content.querySelector(
              ".essub-radio__wrapper"
            );


          if (
            radioWrapper &&
            radioWrapper.parentElement !== row
          ) {

            row.appendChild(
              radioWrapper
            );

          }


          const pricing =
            option.querySelector(
              ".essub-option__right"
            ) ||
            option.querySelector(
              ".essub-pricing"
            );


          if (
            pricing &&
            pricing.parentElement !== row
          ) {

            row.appendChild(
              pricing
            );

          }


          /*
            Description goes directly
            under the row, full width.
          */

          const description =
            option.querySelector(
              ".essub-option__description"
            );


          if (
            description &&
            description.previousElementSibling !== row
          ) {

            row.insertAdjacentElement(
              "afterend",
              description
            );

          }

        }
      );


    /* =======================================================
       SAVE BADGE

       Move "you save $x" badge next to
       the option name instead of the
       price column.
    ======================================================= */

    document
      .querySelectorAll(
        ".essub-option--expanded, .essub-option--compact"
      )
      .forEach(
        option => {

          const badge =
            option.querySelector(
              ".essub-badge, .essub-badge--compact"
            );


          const nameEl =
            option.querySelector(
              ".essub-radio__text"
            );


          if (
            !badge ||
            !nameEl
          ) {
            return;
          }


          /*
            Move only once per render.
          */

          if (
            badge.previousElementSibling !==
            nameEl
          ) {

            nameEl.insertAdjacentElement(
              "afterend",
              badge
            );

          }

        }
      );


    /* =======================================================
       HIDE ALL DESCRIPTIONS
    ======================================================= */

    document
      .querySelectorAll(
        ".essub-option__description"
      )
      .forEach(
        desc => {

          if (
            desc.style.display !==
            "none"
          ) {

            desc.style.display =
              "none";

          }

        }
      );


    /* =======================================================
       FIND ACTIVE OPTION
    ======================================================= */

    const checked =
      document.querySelector(
        ".essub-radio:checked"
      );


    const activeOption =
      checked
        ? checked.closest(
            ".essub-option--expanded, .essub-option--compact"
          )
        : null;


    const activeContent =
      activeOption
        ? (
            activeOption.querySelector(
              ".essub-option__content"
            ) ||
            activeOption.querySelector(
              ".essub-option__left-col"
            )
          )
        : null;


    const activeDescription =
      activeOption
        ? activeOption.querySelector(
            ".essub-option__description"
          )
        : null;


    /* =======================================================
       SHOW ACTIVE DESCRIPTION
    ======================================================= */

    if (activeDescription) {

      activeDescription.style.display =
        "block";

    }


    /* =======================================================
       CUSTOM GIFT CARD
       
       Only active option gets card.
    ======================================================= */

    document
      .querySelectorAll(
        ".custom-gift-card"
      )
      .forEach(
        card => {

          const isCorrectlyPlaced =
            activeContent &&
            card.previousElementSibling ===
              activeContent;


          if (!isCorrectlyPlaced) {

            card.remove();

          }

        }
      );


    if (activeContent) {

      const next =
        activeContent.nextElementSibling;


      if (
        !next ||
        !next.classList.contains(
          "custom-gift-card"
        )
      ) {

        activeContent.insertAdjacentHTML(
          "afterend",
          giftHtml
        );

      }

    }


    /* =======================================================
       REMOVED SECOND TAB GIFT TEXT

       Scrub any strip left in the DOM
       by a cached older script.
    ======================================================= */

    document
      .querySelectorAll(
        ".gift-text-seacond-text"
      )
      .forEach(
        el => {
          el.remove();
        }
      );


    /* =======================================================
       MOST POPULAR
    ======================================================= */

    const firstTabOption =
      document.querySelector(
        '.essub-options--detailed .essub-option--expanded[data-option-index="0"]'
      );


    if (firstTabOption) {

      let popularBadge =
        firstTabOption.querySelector(
          ".gift-text-most-popular"
        );


      if (!popularBadge) {

        firstTabOption.insertAdjacentHTML(
          "afterbegin",
          mostPopularHtml
        );

      } else if (
        popularBadge.parentElement !==
        firstTabOption
      ) {

        firstTabOption.prepend(
          popularBadge
        );

      }

    }


    /* =======================================================
       ONE-TIME PURCHASE BENEFITS
    ======================================================= */

    const thirdTabOption =
      document.querySelector(
        '.essub-options--detailed [data-option-index="2"]'
      );


    if (thirdTabOption) {

      const benefitsEl =
        thirdTabOption.querySelector(
          ".essub-benefits"
        );


      if (benefitsEl) {

        const thirdTabRadio =
          thirdTabOption.querySelector(
            ".essub-radio"
          );


        const isThirdTabChecked =
          !!(
            thirdTabRadio &&
            thirdTabRadio.checked
          );


        const desiredDisplay =
          isThirdTabChecked
            ? "block"
            : "none";


        if (
          benefitsEl.style.display !==
          desiredDisplay
        ) {

          benefitsEl.style.display =
            desiredDisplay;

        }

      }

    }


    /* =======================================================
       STRIP ZERO CENTS

       $39.00 -> $39
       €39,00 -> €39
       $39.99 stays unchanged.
    ======================================================= */

    document
      .querySelectorAll(
        ".essub-pricing__sale, .essub-pricing__compare"
      )
      .forEach(
        priceEl => {

          Array.from(
            priceEl.childNodes
          ).forEach(
            node => {

              if (
                node.nodeType !==
                Node.TEXT_NODE
              ) {
                return;
              }


              const cleaned =
                node.textContent.replace(
                  /([.,])00(?!\d)/g,
                  ""
                );


              if (
                cleaned !==
                node.textContent
              ) {

                node.textContent =
                  cleaned;

              }

            }
          );

        }
      );


    /* =======================================================
       PER-DAY PRICE

       One bag is a 30-day supply and the
       displayed sale price is per bag, so
       /day is the same formula everywhere.
    ======================================================= */

    document
      .querySelectorAll(
        ".essub-pricing"
      )
      .forEach(
        pricing => {

          const saleEl =
            pricing.querySelector(
              ".essub-pricing__sale"
            );


          if (!saleEl) {
            return;
          }


          const textNode =
            Array.from(
              saleEl.childNodes
            ).find(
              node =>
                node.nodeType === Node.TEXT_NODE &&
                node.textContent.trim()
            );


          const raw =
            textNode
              ? textNode.textContent.trim()
              : "";


          const match =
            raw.match(
              /([\d.,]+)/
            );


          if (!match) {
            return;
          }


          const usesCommaDecimal =
            /,\d{1,2}$/.test(
              match[1]
            );


          const normalized =
            usesCommaDecimal
              ? match[1]
                  .replace(/\./g, "")
                  .replace(",", ".")
              : match[1].replace(/,/g, "");


          const amount =
            parseFloat(
              normalized
            );


          if (
            !isFinite(amount) ||
            amount <= 0
          ) {
            return;
          }


          const symbol =
            raw
              .replace(
                match[1],
                ""
              )
              .trim() || "$";


          let perDay =
            (amount / 30).toFixed(2);


          if (usesCommaDecimal) {

            perDay =
              perDay.replace(
                ".",
                ","
              );

          }


          const desired =
            /^\d/.test(raw)
              ? `${perDay}${symbol}/day`
              : `${symbol}${perDay}/day`;


          /*
            Per-day sits AFTER the pricing
            flexbox so the two prices can
            never wrap onto separate lines.
          */

          let perDayEl =
            pricing.nextElementSibling &&
            pricing.nextElementSibling.classList.contains(
              "price-per-day"
            )
              ? pricing.nextElementSibling
              : null;


          if (!perDayEl) {

            perDayEl =
              document.createElement(
                "span"
              );


            perDayEl.className =
              "price-per-day";


            pricing.insertAdjacentElement(
              "afterend",
              perDayEl
            );

          }


          if (
            perDayEl.textContent !==
            desired
          ) {

            perDayEl.textContent =
              desired;

          }

        }
      );


    /* =======================================================
       /BAG SUFFIX
    ======================================================= */

    document
      .querySelectorAll(
        ".essub-pricing__sale"
      )
      .forEach(
        priceEl => {

          if (
            !priceEl.querySelector(
              ".price-suffix"
            )
          ) {

            priceEl.insertAdjacentHTML(
              "beforeend",
              '<span class="price-suffix">/bag</span>'
            );

          }

        }
      );


    /* =======================================================
       ADD TO CART BUTTON PRICE
       
       No compare price.
       
       Example:
       ADD €39.99/bag
       ADD €59.99/bag
       ADD €74.99/bag
    ======================================================= */

    const btnTextEl =
      document.querySelector(
        ".product-form__submit .btn-text"
      );


    if (btnTextEl) {

      const activePriceText =
        getActivePriceText();


      if (activePriceText) {

        const desiredHTML =
          `${activePriceText}/bag`;


        if (
          btnTextEl.innerHTML.trim() !==
          desiredHTML
        ) {

          btnTextEl.innerHTML =
            desiredHTML;

        }

      }

    }


    /* =======================================================
       RELEASE UPDATE LOCK
    ======================================================= */

    setTimeout(
      () => {
        isUpdating = false;
      },
      0
    );

  }


  /* =========================================================
     DEBOUNCE
  ========================================================= */

  let debounceTimer = null;


  function scheduleUpdate() {

    clearTimeout(
      debounceTimer
    );


    debounceTimer =
      setTimeout(
        updateWidget,
        50
      );

  }


  /* =========================================================
     INITIAL RUN
  ========================================================= */

  updateWidget();


  /* =========================================================
     RADIO CHANGE
  ========================================================= */

  document.addEventListener(
    "change",
    function (e) {

      if (
        e.target.matches(
          ".essub-radio"
        )
      ) {

        /*
          Give subscription app time
          to update checked state.
        */

        setTimeout(
          scheduleUpdate,
          30
        );

      }

    }
  );


  /* =========================================================
     OPTION CLICK
  ========================================================= */

  document.addEventListener(
    "click",
    function (e) {

      const option =
        e.target.closest(
          ".essub-option--expanded, .essub-option--compact"
        );


      if (!option) {
        return;
      }


      const radio =
        option.querySelector(
          ".essub-radio"
        );


      if (!radio) {
        return;
      }


      setTimeout(
        scheduleUpdate,
        50
      );

    }
  );


  /* =========================================================
     MUTATION OBSERVER
     
     Watches subscription app re-render.
     
     updateWidget() changes are protected by
     isUpdating so we don't create a loop.
  ======================================================= */

  const observer =
    new MutationObserver(
      function () {

        if (isUpdating) {
          return;
        }


        scheduleUpdate();

      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


});